import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";
import { fetchBranches } from "./branchSlice";

export const fetchBranchById = createAsyncThunk(
  "department/fetchBranchById",
  async (branchId) => {
    const response = await api.get(`/api/branches/${branchId}`);
    return response.data;
  }
);

/** Kurum personeli için tüm şubelerin departmanlarını getirir */
export const fetchAllDepartments = createAsyncThunk(
  "department/fetchAllDepartments",
  async (_, { getState, dispatch }) => {
    await dispatch(fetchBranches()).unwrap();
    const branches = getState().branch.branches;
    const results = await Promise.all(
      branches.map((b) => api.get(`/api/branches/${b.id}`))
    );
    return results.flatMap((res) => {
      const branch = res.data?.data?.branch;
      return (branch?.departments || []).map((d) => ({
        ...d,
        branchId: branch.id,
        branchName: branch.name,
      }));
    });
  }
);

const initialState = {
  branch: null,
  selectedBranchId: null,
  allDepartments: [],
  allDepartmentsLoading: false,
  allDepartmentsError: null,
  selectedDepartmentId: null,
  isLoading: false,
  error: null,
};

const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    clearBranch: (state) => {
      state.branch = null;
      state.selectedBranchId = null;
      state.error = null;
    },
    setSelectedDepartmentId: (state, action) => {
      state.selectedDepartmentId = action.payload;
    },
    clearSelectedDepartment: (state) => {
      state.selectedDepartmentId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchById.pending, (state, action) => {
        state.selectedBranchId = action.meta.arg;
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBranchById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.branch = action.payload?.data?.branch ?? null;
        state.error = null;
      })
      .addCase(fetchBranchById.rejected, (state, action) => {
        state.isLoading = false;
        state.branch = null;
        state.error = action.error.message;
      })
      .addCase(fetchAllDepartments.pending, (state) => {
        state.allDepartmentsLoading = true;
        state.allDepartmentsError = null;
      })
      .addCase(fetchAllDepartments.fulfilled, (state, action) => {
        state.allDepartmentsLoading = false;
        state.allDepartments = action.payload ?? [];
        state.allDepartmentsError = null;
      })
      .addCase(fetchAllDepartments.rejected, (state, action) => {
        state.allDepartmentsLoading = false;
        state.allDepartments = [];
        state.allDepartmentsError = action.error.message;
      });
  },
});

export const { clearBranch, setSelectedDepartmentId, clearSelectedDepartment } =
  departmentSlice.actions;
export default departmentSlice.reducer;
